import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  data: function data() {
    return {
      checked: [],
      checkedAll: false,
      list: [],
      total: 0,
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 2,
      isComponentModalActive: false
    };
  },
  watch: {
    checked: function checked() {
      if (this.checked.length > 0 && this.checked.length === this.list.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    }
  },
  computed: {
    detailData: function detailData() {
      var item = window.sessionStorage.getItem("dataDownLoadDetail");
      return item ? JSON.parse(item) : {};
    },
    checkedAllSize: function checkedAllSize() {
      var _this = this;
      var val = 0;
      if (this.checked.length) {
        this.list.forEach(function (item) {
          _this.checked.forEach(function (chec) {
            if (item.pictureUrl === chec) {
              val += item.pictureSize / 1024;
            }
          });
        });
      }
      return val.toFixed(1);
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.list = [];
              url = "/pjyy-deepexi-product-center/api/v1/product/drug/drugByProductId";
              data = {
                page: _this2.current,
                size: _this2.perPage,
                productId: _this2.detailData.id
              };
              _context.next = 5;
              return _this2.$getHttpClient().post(url, data);
            case 5:
              result = _context.sent;
              _this2.list = result.data.data.list;
              _this2.total = result.data.data.total;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    selectAll: function selectAll() {
      var _this3 = this;
      if (this.checkedAll) {
        // 全不选
        this.checked = [];
      } else {
        // 全选
        this.checked = [];
        this.list.forEach(function (item) {
          _this3.checked.push(item.pictureUrl);
        });
      }
    },
    handleChange: function handleChange(val) {
      this.checked = [];
      this.current = val;
      this.getList();
    },
    onDownload: function onDownload(item) {
      if (item) {
        window.open(item.pictureUrl);
        return;
      }
      if (this.checkedAllSize > 20) {
        this.isComponentModalActive = true;
        return false;
      }
      if (this.checked.length) {
        this.checked.forEach(function (item) {
          window.open(item);
        });
      }
    },
    handleBack: function handleBack() {
      window.history.go(-1);
    }
  }
};